import { Box, Stack } from "@mui/material"

import { Link, useNavigate } from "react-router-dom"

import { BotegaLogoSmall } from "./BotegaLogoSmall"
import FeeDisplay from "./FeeDisplay"
import { Pool } from "@/api/pools-api"

export function PoolWithFee(props: { pool: Pool }) {
  const { pool } = props
  const navigate = useNavigate()

  return (
    <Stack
      alignItems="center"
      sx={{
        background: `var(--mui-palette-background-default)`,
        border: `1px solid var(--mui-palette-primary-main)`,
        borderRadius: 50,
        position: "relative",
        padding: 1,
        opacity: pool.status === "private" ? 0.35 : 1,
      }}
      component={Link}
      to={`/pool/${pool.id}`}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        navigate(`/pool/${pool.id}`)
      }}
    >
      <BotegaLogoSmall width={20} height={20} />
      <Box
        sx={{
          position: "absolute",
          bottom: -12,
          "& span": {
            fontSize: "0.55rem",
            fontWeight: 400,
            padding: 0,
            background: `var(--mui-palette-background-default)`,
            color: `var(--mui-palette-accent-main)`,
          },
        }}
      >
        <FeeDisplay feebps={pool.pool_fee_bps} />
      </Box>
    </Stack>
  )
}
